import BankDisconnectDialog from 'pages/profile/components/ProfileTabContent/Bank&Transfers/components/BankStateSection/components/BankDisconnectDialog';
import BankStateLeftSection from 'pages/profile/components/ProfileTabContent/Bank&Transfers/components/BankStateSection/components/BankStateLeftSection';
import BankStateRightSection from 'pages/profile/components/ProfileTabContent/Bank&Transfers/components/BankStateSection/components/BankStateRightSection';
import useBankStateSectionData from 'pages/profile/components/ProfileTabContent/Bank&Transfers/components/BankStateSection/useBankStateSectionData';
import ProfileSection from 'pages/profile/components/ProfileTabContent/components/ProfileSection';
import classes from './index.module.scss';
import MicroDepositDialog from 'components/dialogs/MicroDepositDialog';

import { USER_STATUS } from 'consts/User/status';
import Button from 'components/generics/buttons/Button';
import { useState } from 'react';

const BankStateSection = () => {
  const {
    bankTitle,
    accountDigits,
    buttonText,
    disabled,
    openBankDialog,
    closeBankDialog,
    modalOpen,
    onClick,
    disconnectClick = () => {},
    loading,
    disconnectOpen,
    setDisconnectOpen,
    userState,
    isMicroDepositOpen,
    closeMicroDepositDialog,
  } = useBankStateSectionData(false);

  return (
    <>
      <ProfileSection
        title={'My Bank Account'}
        titleClassName={classes.title}
        withBottomLine
      >
        <div className={classes.bankRow}>
          <BankStateLeftSection
            bankTitle={bankTitle}
            loading={loading}
            accountDigits={accountDigits}
          />
          <BankStateRightSection
            modalOpen={modalOpen}
            handleClose={closeBankDialog}
            loading={loading}
            onClick={() => onClick?.()}
            disabled={disabled}
            buttonText={buttonText}
            disconnectClick={disconnectClick}
          />
        </div>
        <BankDisconnectDialog
          isOpen={disconnectOpen}
          onClose={() => setDisconnectOpen(false)}
        />
      </ProfileSection>

      {userState == USER_STATUS.BANK_REQUIRES_VERIFICATION && (
        <Button
          onClick={onClick}
          className={classes.buttonMicroDeposit}
        >
          Enter Micro Deposit
        </Button>
      )}

      <BankDisconnectDialog
        isOpen={disconnectOpen}
        onClose={() => setDisconnectOpen(false)}
      />
      <MicroDepositDialog
        isOpen={isMicroDepositOpen}
        onClose={closeMicroDepositDialog}
      />
    </>
  );
};

export default BankStateSection;
